import { render, staticRenderFns } from "./ShippingReceiptReport.vue?vue&type=template&id=65f86c56"
import script from "./ShippingReceiptReport.vue?vue&type=script&lang=js"
export * from "./ShippingReceiptReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports